// product Interface display size as a percentage of the Skin image
export const ButtonPercentSizeOfSkin = 14.6

// scaling factor for interface images to allow for correct clipping to a rounded rectangle
export const ButtonImageOverflowScaleMultiplier = 1.29